import { FC, useMemo } from 'react';

import type { GetCurrentActivitiesEditorsSubscription } from '../lesson-builder.graphql.generated';
import ActiveEditorAvatar from './active-editor-avatar';
import useUserData from 'approot/shared/user/user-data';
import { Box } from 'approot/shared/design-system/box/box.style';
import { getColorForUser } from './logic/get-colour-for-user';
import type { Pluck } from 'lib/gql/pluck';

interface ActiveEditorsDisplayProps {
  editors: Pluck<
    GetCurrentActivitiesEditorsSubscription,
    'getCurrentActivitiesEditors'
  >[];
}

const ActiveEditorsDisplay: FC<ActiveEditorsDisplayProps> = ({ editors }) => {
  const { user } = useUserData();
  const currentUserId = user?.id;

  // Filter out the current user - we only show other editors
  const otherEditors = useMemo(
    () => editors.filter(editor => editor.editorId !== currentUserId),
    [editors, currentUserId]
  );

  if (otherEditors.length === 0) {
    return null;
  }

  return (
    <Box $gap={8} $marginRight={16}>
      {otherEditors.map(editor => (
        <ActiveEditorAvatar
          key={editor.editorId}
          editor={editor}
          colorName={getColorForUser(String(editor.editorId))}
        />
      ))}
    </Box>
  );
};

export default ActiveEditorsDisplay;
